module.exports = __webpack_public_path__ + "img/KSC02179.bbc16985.jpg";